/* TailorTail Co — Product Form (Variants & Add to Cart) */

(function() {
  'use strict';

  var productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;

  var product = JSON.parse(productJson.textContent);
  var form = document.querySelector('[data-product-form]');
  var variantSelects = form.querySelectorAll('[data-variant-select]');
  var variantIdInput = form.querySelector('[data-variant-id]');
  var mainImage = document.querySelector('[data-product-image]');
  var thumbnails = document.querySelectorAll('[data-thumbnail]');
  var priceEl = document.querySelector('[data-product-price]');
  var comparePriceEl = document.querySelector('[data-product-compare-price]');
  var addToCartBtn = form.querySelector('[data-add-to-cart]');
  var artStyleSelect = form.querySelector('[data-art-style]');

  // Hide variant-only images on initial load
  thumbnails.forEach(function(thumb) {
    var img = thumb.querySelector('img');
    var alt = img ? img.getAttribute('alt') || '' : '';
    if (alt.toLowerCase().includes('variant-only')) {
      thumb.style.display = 'none';
    }
  });

  // Variant selection (dropdowns)
  variantSelects.forEach(function(select) {
    select.addEventListener('change', updateVariant);
  });

  // Size & Color button/swatch selectors
  var optionButtons = form.querySelectorAll('[data-option-value]');
  optionButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var value = this.getAttribute('data-option-value');

      var group = this.closest('.size-selector, .color-swatch-group, .size-cards');
      if (group) {
        group.querySelectorAll('[data-option-value]').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
      }
      this.classList.add('is-active');
      this.setAttribute('aria-pressed', 'true');

      var formGroup = this.closest('.form-group');
      var hiddenSelect = formGroup ? formGroup.querySelector('[data-variant-select]') : null;
      if (!hiddenSelect && this.closest('.size-cards')) {
        hiddenSelect = form.querySelector('#Option-size');
      }
      if (hiddenSelect) {
        hiddenSelect.value = value;
      }

      var colorLabel = this.closest('.form-group').querySelector('[data-selected-color]');
      if (colorLabel) {
        colorLabel.textContent = value;
      }

      updateVariant();
    });
  });

  function updateVariant() {
    var selectedOptions = [];
    variantSelects.forEach(function(select) {
      selectedOptions.push(select.value);
    });

    var variant = product.variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return opt === selectedOptions[i];
      });
    });

    if (!variant) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Unavailable';
      return;
    }

    variantIdInput.value = variant.id;

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.classList.add('text-primary');
        if (comparePriceEl) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        }
      } else {
        priceEl.classList.remove('text-primary');
        if (comparePriceEl) {
          comparePriceEl.style.display = 'none';
        }
      }
    }

    if (variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart';
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    }

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = variant.featured_image.src + ' 900w';
    }

    // Filter gallery thumbnails by variant alt text (country first, then generic fallback)
    var filterValue = null;
    var countryOptionIndex = product.options.findIndex(function(o) {
      return o.toLowerCase().replace(/\s+/g, '-') === 'country';
    });
    if (countryOptionIndex >= 0) {
      filterValue = variant.options[countryOptionIndex];
    }

    if (!filterValue && thumbnails.length > 0) {
      for (var oi = 0; oi < product.options.length; oi++) {
        if (oi === countryOptionIndex) continue;
        var optVal = variant.options[oi];
        if (!optVal || optVal.length <= 2) continue;
        var hasMatch = Array.from(thumbnails).some(function(thumb) {
          var img = thumb.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          var altLower = alt.toLowerCase();
          return !altLower.includes('always') && !altLower.includes('variant-only') && altLower.includes(optVal.toLowerCase());
        });
        if (hasMatch) { filterValue = optVal; break; }
      }
    }

    if (thumbnails.length > 0) {
      if (filterValue) {
        var hasMatchingImages = false;
        thumbnails.forEach(function(thumb) {
          var img = thumb.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          var altLower = alt.toLowerCase();
          if (!altLower.includes('always') && altLower.includes(filterValue.toLowerCase())) hasMatchingImages = true;
        });

        thumbnails.forEach(function(thumb) {
          var img = thumb.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          var altLower = alt.toLowerCase();
          var isAlways = altLower.includes('always');
          var isVariantOnly = altLower.includes('variant-only');
          var matchesFilter = altLower.includes(filterValue.toLowerCase());

          if (isAlways) {
            thumb.style.display = '';
          } else if (hasMatchingImages) {
            thumb.style.display = matchesFilter ? '' : 'none';
          } else {
            thumb.style.display = isVariantOnly ? 'none' : '';
          }
        });
        var firstVisible = Array.from(thumbnails).find(function(t) { return t.style.display !== 'none'; });
        if (firstVisible && !firstVisible.classList.contains('is-active')) firstVisible.click();
      } else {
        thumbnails.forEach(function(thumb) {
          var img = thumb.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          var isVariantOnly = alt.toLowerCase().includes('variant-only');
          thumb.style.display = isVariantOnly ? 'none' : '';
        });
      }
    }

    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  // Art style visual cards
  var artStyleCards = document.querySelector('[data-art-style-cards]');
  if (artStyleCards && artStyleSelect) {
    var styleCardBtns = artStyleCards.querySelectorAll('.art-style-card');
    styleCardBtns.forEach(function(card) {
      card.addEventListener('click', function() {
        var value = this.getAttribute('data-style-value');

        styleCardBtns.forEach(function(c) { c.setAttribute('aria-pressed', 'false'); });
        this.setAttribute('aria-pressed', 'true');

        artStyleSelect.value = value;
        artStyleSelect.dispatchEvent(new Event('change'));

        // If variant-backed, trigger variant resolution
        if (this.hasAttribute('data-option-value')) {
          updateVariant();
        }
      });
    });
  }

  // Pet Count Cards (Desktop)
  var petCountCards = form.querySelectorAll('[data-pet-count-cards] .pet-count-card');
  var petCountSelect = form.querySelector('[data-pet-count-select]');

  if (petCountCards.length) {
    petCountCards.forEach(function(card) {
      card.addEventListener('click', function() {
        petCountCards.forEach(function(c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        if (petCountSelect) {
          petCountSelect.value = this.getAttribute('data-pet-count-value');
        }
        updateVariant();

        var count = parseInt(this.getAttribute('data-pet-count') || '1', 10);
        updateUploadSlots(count);
      });
    });
  }

  function updateUploadSlots(count) {
    var extraSlots = document.querySelectorAll('[data-extra-upload]');
    extraSlots.forEach(function(slot) {
      var slotNum = parseInt(slot.getAttribute('data-extra-upload'), 10);
      slot.hidden = slotNum > count;
    });

    var uploadTitle = document.querySelector('[data-upload-title]');
    if (uploadTitle) {
      uploadTitle.textContent = count > 1 ? "Upload Your Pets' Photos" : "Upload Your Pet's Photo";
    }

    var multiHelper = document.querySelector('[data-multi-upload-helper]');
    if (multiHelper) {
      multiHelper.hidden = count <= 1;
    }
  }

  // ─── Bundle Selector Logic ───
  var bundleSelector = form.querySelector('[data-bundle-selector]');
  var currentBundleSize = 1;

  if (bundleSelector) {
    var bundleBtns = bundleSelector.querySelectorAll('[data-bundle-size]');
    var bundlePetCards = bundleSelector.querySelectorAll('[data-bundle-pet-card]');
    var bundleSizeInput = bundleSelector.querySelector('[data-bundle-size-input]');
    var bundleDiscountInput = bundleSelector.querySelector('[data-bundle-discount-input]');
    var bundlePriceDisplay = bundleSelector.querySelector('[data-bundle-price-display]');

    var bundleDiscounts = {
      1: 0,
      2: parseFloat(bundleSelector.getAttribute('data-discount-2')) || 5,
      3: parseFloat(bundleSelector.getAttribute('data-discount-3')) || 10,
      4: parseFloat(bundleSelector.getAttribute('data-discount-4')) || 15
    };

    function showBundleIfReady() {
      var sizeSelected = form.querySelector('.size-card.is-active, .size-selector__btn.is-active');
      if (sizeSelected) {
        bundleSelector.hidden = false;
      }
    }

    bundleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        bundleBtns.forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        currentBundleSize = parseInt(this.getAttribute('data-bundle-size'), 10);
        bundleSizeInput.value = currentBundleSize;

        updateBundleCards();
        updateBundlePrice();
      });
    });

    function updateBundleCards() {
      bundlePetCards.forEach(function(card) { card.hidden = true; });

      if (currentBundleSize <= 1) return;

      var card2 = bundleSelector.querySelector('[data-bundle-pet-card="2"]');
      if (card2) card2.hidden = false;

      for (var i = 3; i <= currentBundleSize; i++) {
        if (isBundleCardComplete(i - 1)) {
          var card = bundleSelector.querySelector('[data-bundle-pet-card="' + i + '"]');
          if (card) card.hidden = false;
        }
      }

      updateBundleCardStatuses();
    }

    function isBundleCardComplete(index) {
      var nameInput = bundleSelector.querySelector('[data-bundle-pet-name="' + index + '"]');
      var photoInput = form.querySelector('input[name="properties[_Pet Photo ' + index + ']"]');
      return nameInput && nameInput.value.trim() !== '' && photoInput && photoInput.value !== '';
    }

    function updateBundleCardStatuses() {
      for (var i = 2; i <= 4; i++) {
        var statusEl = bundleSelector.querySelector('[data-bundle-card-status="' + i + '"]');
        if (statusEl) {
          if (isBundleCardComplete(i)) {
            statusEl.textContent = 'Complete';
            statusEl.classList.add('is-complete');
          } else {
            statusEl.textContent = 'Incomplete';
            statusEl.classList.remove('is-complete');
          }
        }
      }
    }

    function updateBundlePrice() {
      var variantId = variantIdInput.value;
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id == variantId) {
          variant = product.variants[i];
          break;
        }
      }
      if (!variant) return;

      var unitPrice = variant.price;
      var totalPrice = unitPrice * currentBundleSize;
      var discount = bundleDiscounts[currentBundleSize] * 100;
      var finalPrice = totalPrice - discount;

      if (currentBundleSize > 1) {
        bundlePriceDisplay.hidden = false;
        bundlePriceDisplay.querySelector('[data-bundle-original]').textContent = formatMoney(totalPrice);
        bundlePriceDisplay.querySelector('[data-bundle-final]').textContent = formatMoney(finalPrice);
        bundlePriceDisplay.querySelector('[data-bundle-savings]').textContent = 'You save ' + formatMoney(discount);
        bundleDiscountInput.value = '$' + bundleDiscounts[currentBundleSize].toFixed(2);
      } else {
        bundlePriceDisplay.hidden = true;
        bundleDiscountInput.value = '';
      }
    }

    // "Same as Pet 1" toggles
    bundleSelector.querySelectorAll('[data-bundle-same-color]').forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        var index = this.getAttribute('data-bundle-same-color');
        var swatches = bundleSelector.querySelector('[data-bundle-color-swatches="' + index + '"]');
        var colorInput = bundleSelector.querySelector('[data-bundle-color-input="' + index + '"]');
        if (this.checked) {
          swatches.hidden = true;
          colorInput.value = '';
        } else {
          swatches.hidden = false;
        }
      });
    });

    // Bundle color swatch clicks
    bundleSelector.querySelectorAll('[data-bundle-color-value]').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var index = this.getAttribute('data-pet-index');
        var group = this.closest('[data-bundle-color-swatches]');
        group.querySelectorAll('[data-bundle-color-value]').forEach(function(s) {
          s.classList.remove('is-active');
        });
        this.classList.add('is-active');
        var colorInput = bundleSelector.querySelector('[data-bundle-color-input="' + index + '"]');
        colorInput.value = this.getAttribute('data-bundle-color-value');
      });
    });

    // Sequential expansion: listen for inputs to reveal next card
    bundleSelector.addEventListener('input', function(e) {
      if (e.target.matches('[data-bundle-pet-name]')) {
        clearTimeout(bundleSelector._expandTimer);
        bundleSelector._expandTimer = setTimeout(function() {
          updateBundleCards();
        }, 300);
      }
    });

    // Listen for photo upload completions (change on hidden URL inputs)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'value') {
          updateBundleCards();
        }
      });
    });
    for (var pi = 2; pi <= 4; pi++) {
      var photoInput = form.querySelector('input[name="properties[_Pet Photo ' + pi + ']"]');
      if (photoInput) {
        observer.observe(photoInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    // Show bundle after size is selected
    form.addEventListener('click', function(e) {
      var target = e.target.closest('[data-option-value]');
      if (target) {
        setTimeout(showBundleIfReady, 50);
        setTimeout(updateBundlePrice, 100);
      }
    });

    showBundleIfReady();
  }

  // Art style filters gallery by alt text (same approach as country flags)
  if (artStyleSelect && thumbnails.length > 0) {
    artStyleSelect.addEventListener('change', function() {
      var styleValue = this.value;
      if (!styleValue) return;

      var hasMatchingImages = false;
      thumbnails.forEach(function(thumb) {
        var img = thumb.querySelector('img');
        var alt = img ? img.getAttribute('alt') || '' : '';
        var altLower = alt.toLowerCase();
        if (!altLower.includes('always') && !altLower.includes('variant-only') && altLower.includes(styleValue.toLowerCase())) {
          hasMatchingImages = true;
        }
      });

      if (hasMatchingImages) {
        thumbnails.forEach(function(thumb) {
          var img = thumb.querySelector('img');
          var alt = img ? img.getAttribute('alt') || '' : '';
          var altLower = alt.toLowerCase();
          var isAlways = altLower.includes('always');
          var matchesFilter = altLower.includes(styleValue.toLowerCase());

          if (isAlways) {
            thumb.style.display = '';
          } else {
            thumb.style.display = matchesFilter ? '' : 'none';
          }
        });
        var firstVisible = Array.from(thumbnails).find(function(t) { return t.style.display !== 'none'; });
        if (firstVisible && !firstVisible.classList.contains('is-active')) firstVisible.click();
      }
    });
  }

  // Delivery estimate (dynamic date)
  var deliveryEl = document.querySelector('[data-delivery-text]');
  if (deliveryEl) {
    var today = new Date();
    var artworkDate = new Date(today);
    artworkDate.setDate(artworkDate.getDate() + 2);
    var shipDate = new Date(today);
    shipDate.setDate(shipDate.getDate() + 7);

    var opts = { month: 'short', day: 'numeric' };
    var artworkStr = artworkDate.toLocaleDateString('en-US', opts);
    var shipStr = shipDate.toLocaleDateString('en-US', opts);

    deliveryEl.innerHTML = 'Order today &rarr; Artwork ready by ' + artworkStr + ' &rarr; Ships by ' + shipStr;
  }

  // Video elements
  var videoWrapper = document.querySelector('[data-product-video-wrapper]');
  var videoEl = document.querySelector('[data-product-video]');
  var videoExternal = document.querySelector('[data-product-video-external]');

  // Thumbnail clicks (supports images + video)
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mediaType = this.getAttribute('data-media-type') || 'image';

      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');

      if (mediaType === 'image') {
        var imageUrl = this.getAttribute('data-image-url');
        showImage(imageUrl);
      } else if (mediaType === 'video') {
        var videoUrl = this.getAttribute('data-video-url');
        showVideo(videoUrl, 'native');
      } else if (mediaType === 'external_video') {
        var extUrl = this.getAttribute('data-video-url');
        showVideo(extUrl, 'external');
      }

    });
  });

  // Gallery arrow navigation (desktop)
  var galleryPrev = document.querySelector('[data-gallery-prev]');
  var galleryNext = document.querySelector('[data-gallery-next]');

  function getActiveThumbIndex() {
    for (var i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  if (galleryPrev && galleryNext && thumbnails.length > 1) {
    galleryPrev.addEventListener('click', function() {
      var visible = Array.from(thumbnails).filter(function(t) { return t.style.display !== 'none'; });
      if (visible.length < 2) return;
      var activeIdx = visible.findIndex(function(t) { return t.classList.contains('is-active'); });
      if (activeIdx === -1) activeIdx = 0;
      var nextIdx = activeIdx > 0 ? activeIdx - 1 : visible.length - 1;
      visible[nextIdx].click();
    });

    galleryNext.addEventListener('click', function() {
      var visible = Array.from(thumbnails).filter(function(t) { return t.style.display !== 'none'; });
      if (visible.length < 2) return;
      var activeIdx = visible.findIndex(function(t) { return t.classList.contains('is-active'); });
      if (activeIdx === -1) activeIdx = 0;
      var nextIdx = activeIdx < visible.length - 1 ? activeIdx + 1 : 0;
      visible[nextIdx].click();
    });
  }

  function showImage(src) {
    if (videoWrapper) videoWrapper.hidden = true;
    if (videoEl) { videoEl.pause(); videoEl.src = ''; }
    if (videoExternal) { videoExternal.src = ''; videoExternal.hidden = true; }
    if (mainImage) {
      mainImage.hidden = false;
      mainImage.src = src;
      mainImage.srcset = src + ' 900w';
    }
  }

  function showVideo(url, type) {
    if (mainImage) mainImage.hidden = true;
    if (videoWrapper) videoWrapper.hidden = false;

    if (type === 'native') {
      if (videoExternal) videoExternal.hidden = true;
      if (videoEl) {
        videoEl.hidden = false;
        videoEl.src = url;
        videoEl.play().catch(function() {});
      }
    } else {
      if (videoEl) { videoEl.hidden = true; videoEl.pause(); }
      if (videoExternal) {
        videoExternal.hidden = false;
        videoExternal.src = url;
      }
    }
  }

  function updateMainImage(src) {
    showImage(src);
  }

  // Form validation
  function validateForm() {
    var isValid = true;
    var requiredFields = form.querySelectorAll('[required]');

    requiredFields.forEach(function(field) {
      var group = field.closest('.form-group');
      var errorEl = group ? group.querySelector('.form-error') : null;

      if (!field.value.trim()) {
        isValid = false;
        field.setAttribute('aria-invalid', 'true');
        field.classList.add('form-input--error');
        if (errorEl) {
          errorEl.hidden = false;
        }
      } else {
        field.removeAttribute('aria-invalid');
        field.classList.remove('form-input--error');
        if (errorEl) {
          errorEl.hidden = true;
        }
      }
    });

    // Validate photo upload (first slot is required unless optional)
    var uploadGroup = form.querySelector('[data-photo-upload-group]');
    if (uploadGroup && uploadGroup.getAttribute('data-upload-optional') !== 'true') {
      var firstUpload = uploadGroup.querySelector('[data-photo-upload]');
      if (firstUpload) {
        var photoUrl = firstUpload.querySelector('[data-photo-url]');
        var dropzone = firstUpload.querySelector('[data-upload-dropzone]');
        if (photoUrl && !photoUrl.value) {
          isValid = false;
          if (dropzone) dropzone.classList.add('photo-upload__dropzone--error');
          var photoError = uploadGroup.querySelector('.form-error');
          if (photoError) photoError.hidden = false;
        } else {
          if (dropzone) dropzone.classList.remove('photo-upload__dropzone--error');
          var photoError = uploadGroup.querySelector('.form-error');
          if (photoError) photoError.hidden = true;
        }
      }
    }

    return isValid;
  }

  // Clear validation on change
  form.querySelectorAll('[required]').forEach(function(field) {
    field.addEventListener('change', function() {
      if (field.value) {
        field.removeAttribute('aria-invalid');
        field.classList.remove('form-input--error');
        var group = field.closest('.form-group');
        var errorEl = group ? group.querySelector('.form-error') : null;
        if (errorEl) errorEl.hidden = true;
      }
    });
  });

  // Add to Cart via AJAX
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    if (!validateForm()) {
      var firstInvalid = form.querySelector('[aria-invalid="true"]');
      if (firstInvalid) firstInvalid.focus();
      return;
    }

    var formData = new FormData(form);
    var variantId = Number(variantIdInput.value);
    if (!variantId || isNaN(variantId)) {
      var errorMsg = form.querySelector('.product-form__error');
      if (errorMsg) {
        errorMsg.textContent = 'Please select all product options before adding to cart.';
        errorMsg.hidden = false;
        setTimeout(function() { errorMsg.hidden = true; }, 5000);
      }
      return;
    }
    var data = {
      id: variantId,
      quantity: currentBundleSize || 1,
      properties: {}
    };

    for (var pair of formData.entries()) {
      if (pair[0].startsWith('properties[')) {
        var key = pair[0].replace('properties[', '').replace(']', '');
        if (pair[1]) data.properties[key] = pair[1];
      }
    }

    // Strip bundle properties when not using bundles
    if (!currentBundleSize || currentBundleSize <= 1) {
      delete data.properties['_Bundle Size'];
      delete data.properties['_Bundle Discount'];
      Object.keys(data.properties).forEach(function(k) {
        if (/^(Color|Pet Name|_Pet Photo) [234]$/.test(k)) {
          delete data.properties[k];
        }
      });
    } else {
      // Strip properties for bundle slots beyond selected size
      for (var s = currentBundleSize + 1; s <= 4; s++) {
        delete data.properties['Color ' + s];
        delete data.properties['Pet Name ' + s];
        delete data.properties['_Pet Photo ' + s];
      }
    }

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err) { throw new Error(err.description || err.message || 'Failed to add to cart'); });
      return res.json();
    })
    .then(function() {
      addToCartBtn.textContent = 'Added!';
      addToCartBtn.style.backgroundColor = 'var(--color-secondary)';

      return fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' }
      });
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      if (window.TailorTail && window.TailorTail.updateCartCount) {
        window.TailorTail.updateCartCount(cart.item_count);
      }
      if (window.TailorTail && window.TailorTail.openCartDrawer) {
        window.TailorTail.openCartDrawer();
      }

      setTimeout(function() {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
        addToCartBtn.style.backgroundColor = '';
      }, 2000);
    })
    .catch(function(err) {
      console.error('Add to cart error:', err, 'Variant ID:', data.id);
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to Cart';
      var errorMsg = form.querySelector('.product-form__error');
      if (errorMsg) {
        errorMsg.textContent = err.message || 'Could not add to cart. Please try again.';
        errorMsg.hidden = false;
        setTimeout(function() { errorMsg.hidden = true; }, 5000);
      }
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Tabbed content with ARIA
  var tabNav = document.querySelector('[data-product-tabs] .product-main__tab-nav');
  var tabBtns = document.querySelectorAll('[data-tab]');
  var tabPanels = document.querySelectorAll('[data-tab-panel]');

  if (tabNav) {
    tabNav.setAttribute('role', 'tablist');

    tabBtns.forEach(function(btn, index) {
      var tabId = 'product-tab-' + btn.getAttribute('data-tab');
      var panelId = 'product-panel-' + btn.getAttribute('data-tab');
      var panel = document.querySelector('[data-tab-panel="' + btn.getAttribute('data-tab') + '"]');

      btn.setAttribute('role', 'tab');
      btn.setAttribute('id', tabId);
      btn.setAttribute('aria-controls', panelId);
      btn.setAttribute('aria-selected', btn.classList.contains('is-active') ? 'true' : 'false');
      btn.setAttribute('tabindex', btn.classList.contains('is-active') ? '0' : '-1');

      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('id', panelId);
        panel.setAttribute('aria-labelledby', tabId);
        panel.setAttribute('tabindex', '0');
      }

      btn.addEventListener('click', function() {
        activateTab(btn);
      });

      btn.addEventListener('keydown', function(e) {
        var tabs = Array.from(tabBtns);
        var currentIndex = tabs.indexOf(btn);

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          var next = tabs[(currentIndex + 1) % tabs.length];
          activateTab(next);
          next.focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
          activateTab(prev);
          prev.focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          activateTab(tabs[0]);
          tabs[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          activateTab(tabs[tabs.length - 1]);
          tabs[tabs.length - 1].focus();
        }
      });
    });
  }

  function activateTab(selectedBtn) {
    tabBtns.forEach(function(btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');
    });
    tabPanels.forEach(function(p) { p.classList.remove('is-active'); });

    selectedBtn.classList.add('is-active');
    selectedBtn.setAttribute('aria-selected', 'true');
    selectedBtn.setAttribute('tabindex', '0');

    var panel = document.querySelector('[data-tab-panel="' + selectedBtn.getAttribute('data-tab') + '"]');
    if (panel) panel.classList.add('is-active');
  }

  // Sticky ATC bar (desktop + mobile wizard)
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var stickyBtn = document.querySelector('[data-sticky-atc-btn]');

  // Desktop: observe the standard add-to-cart button
  if (addToCartBtn && stickyBar) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      stickyBar.hidden = false;
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    stickyObserver.observe(addToCartBtn);

    if (stickyBtn && !document.querySelector('[data-product-wizard]')) {
      stickyBtn.addEventListener('click', function() {
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit'));
      });
    }
  }

  // Mobile wizard: always show sticky bar when wizard is present
  var wizardEl = document.querySelector('.product-wizard');
  if (wizardEl && stickyBar) {
    stickyBar.hidden = false;
    stickyBar.classList.add('is-visible');
    updateStickyWizardLabel();
  }

  function updateStickyWizardLabel() {
    if (!stickyBtn) return;
    var activeStep = document.querySelector('.product-wizard__step.is-active');
    if (!activeStep) return;
    var atcBtn = activeStep.querySelector('[data-wizard-submit]');
    var nextBtn = activeStep.querySelector('[data-wizard-next]');
    if (atcBtn && !atcBtn.disabled) {
      var priceEl = atcBtn.querySelector('[data-wizard-atc-price]');
      stickyBtn.textContent = priceEl ? 'Add to Cart — ' + priceEl.textContent : 'Add to Cart';
    } else if (atcBtn && atcBtn.disabled) {
      stickyBtn.textContent = 'Sold Out';
    } else if (nextBtn) {
      stickyBtn.textContent = nextBtn.textContent.trim();
    }
  }

  if (stickyBtn && wizardEl) {
    var stickyBusy = false;
    stickyBtn.addEventListener('click', function() {
      if (stickyBusy) return;
      stickyBusy = true;
      var activeStep = document.querySelector('.product-wizard__step.is-active');
      if (!activeStep) { stickyBusy = false; return; }
      var atcBtn = activeStep.querySelector('[data-wizard-submit]');
      var nextBtn = activeStep.querySelector('[data-wizard-next]');
      if (atcBtn) atcBtn.click();
      else if (nextBtn) nextBtn.click();
      setTimeout(function() { stickyBusy = false; updateStickyWizardLabel(); }, 700);
    });
  }

  // Re-sync label whenever wizard step changes
  document.addEventListener('wizard:step-changed', updateStickyWizardLabel);

  // Image zoom: keyboard accessible (Enter/Space to toggle)
  var imageWrapper = document.querySelector('.product-main__image-wrapper');
  if (imageWrapper && mainImage) {
    imageWrapper.setAttribute('tabindex', '0');
    imageWrapper.setAttribute('role', 'button');
    imageWrapper.setAttribute('aria-label', 'Zoom product image');

    var isZoomed = false;

    imageWrapper.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        isZoomed = !isZoomed;
        if (isZoomed) {
          mainImage.style.transform = 'scale(1.8)';
          mainImage.style.transformOrigin = 'center center';
          imageWrapper.setAttribute('aria-label', 'Exit zoom');
        } else {
          mainImage.style.transform = 'scale(1)';
          imageWrapper.setAttribute('aria-label', 'Zoom product image');
        }
      } else if (e.key === 'Escape' && isZoomed) {
        isZoomed = false;
        mainImage.style.transform = 'scale(1)';
        imageWrapper.setAttribute('aria-label', 'Zoom product image');
      }
    });

    if (!('ontouchstart' in window)) {
      imageWrapper.addEventListener('mouseenter', function() {
        if (!isZoomed) {
          mainImage.style.transform = 'scale(1.8)';
          mainImage.style.transition = 'transform 150ms ease';
        }
      });
      imageWrapper.addEventListener('mousemove', function(e) {
        var rect = imageWrapper.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImage.style.transformOrigin = x + '% ' + y + '%';
      });
      imageWrapper.addEventListener('mouseleave', function() {
        if (!isZoomed) {
          mainImage.style.transformOrigin = '';
          mainImage.style.transform = '';
          mainImage.style.transition = '';
        }
      });
    }
  }

  // Thumbnail overflow detection
  var thumbContainer = document.querySelector('.product-main__thumbnails');
  if (thumbContainer) {
    function checkThumbOverflow() {
      if (thumbContainer.scrollWidth <= thumbContainer.clientWidth) {
        thumbContainer.classList.add('product-main__thumbnails--no-overflow');
      } else {
        thumbContainer.classList.remove('product-main__thumbnails--no-overflow');
      }
    }
    checkThumbOverflow();
    window.addEventListener('resize', checkThumbOverflow);

    thumbContainer.addEventListener('scroll', function() {
      var atEnd = thumbContainer.scrollLeft + thumbContainer.clientWidth >= thumbContainer.scrollWidth - 4;
      if (atEnd) {
        thumbContainer.style.maskImage = 'none';
        thumbContainer.style.webkitMaskImage = 'none';
      } else {
        thumbContainer.style.maskImage = '';
        thumbContainer.style.webkitMaskImage = '';
      }
    });
  }

  // Size chart unit toggle
  var unitTabs = document.querySelectorAll('[data-unit-tab]');
  var unitPanels = document.querySelectorAll('[data-unit-panel]');

  if (unitTabs.length > 0) {
    unitTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var unit = this.getAttribute('data-unit-tab');

        unitTabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        unitPanels.forEach(function(panel) {
          panel.hidden = panel.getAttribute('data-unit-panel') !== unit;
        });
      });
    });
  }

  // Ensure variant ID is set correctly on page load
  updateVariant();
})();

/* ═══════════════════════════════════════════════════════════════════════
   COUNTRY SELECTOR — Shared between desktop form and mobile wizard
   ═══════════════════════════════════════════════════════════════════════ */
function initCountrySelector(container) {
  var selectors = container.querySelectorAll('[data-country-selector]');
  if (!selectors.length) return;

  var countryVariantSelect = container.querySelector('[data-country-variant-select]');

  selectors.forEach(function(selector) {
    var options = selector.querySelectorAll('[data-country-value]');
    var radios = selector.querySelectorAll('[data-country-radio]');
    var customWrapper = selector.querySelector('[data-country-custom-wrapper]');
    var customInput = selector.querySelector('[data-country-custom-input]');
    var valueInput = selector.querySelector('[data-country-value-input]');
    var countryError = selector.querySelector('[data-country-error]');
    var customError = selector.querySelector('[data-country-custom-error]');

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        var value = this.value;

        options.forEach(function(opt) { opt.classList.remove('is-selected'); });
        this.closest('[data-country-value]').classList.add('is-selected');

        if (countryError) countryError.hidden = true;

        if (value === 'Your Country') {
          customWrapper.hidden = false;
          if (customInput) {
            customInput.setAttribute('required', '');
            customInput.focus();
          }
          valueInput.value = '';
          if (countryVariantSelect) {
            countryVariantSelect.value = value;
            countryVariantSelect.dispatchEvent(new Event('change'));
          }
        } else {
          customWrapper.hidden = true;
          if (customInput) {
            customInput.removeAttribute('required');
            customInput.value = '';
            customInput.classList.remove('form-input--error');
          }
          if (customError) customError.hidden = true;
          valueInput.value = value;

          if (countryVariantSelect) {
            countryVariantSelect.value = value;
            countryVariantSelect.dispatchEvent(new Event('change'));
          }
        }
      });
    });

    if (customInput) {
      customInput.addEventListener('input', function() {
        if (this.value.trim()) {
          valueInput.value = this.value.trim();
          this.classList.remove('form-input--error');
          if (customError) customError.hidden = true;
          if (countryVariantSelect) {
            countryVariantSelect.value = 'Your Country';
            countryVariantSelect.dispatchEvent(new Event('change'));
          }
        } else {
          valueInput.value = '';
        }
      });
    }
  });
}

(function() {
  'use strict';
  var desktopForm = document.querySelector('[data-product-form]');
  if (desktopForm) initCountrySelector(desktopForm.closest('.product-main--desktop') || desktopForm.parentElement);
})();

/* ═══════════════════════════════════════════════════════════════════════
   MOBILE WIZARD — Instagram Shop Optimized
   Swipeable step wizard with button navigation.
   Only initializes if [data-product-wizard] exists (mobile view).
   ═══════════════════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  var wizard = document.querySelector('[data-product-wizard]');
  if (!wizard) return;

  var productJson = document.querySelector('[data-wizard-product-json]');
  var product = productJson ? JSON.parse(productJson.textContent) : null;
  var wizardForm = document.querySelector('[data-wizard-form]');
  var variantIdInput = wizard.querySelector('[data-wizard-variant-id]');

  var steps = Array.from(wizard.querySelectorAll('[data-wizard-step]'));
  var dots = Array.from(wizard.querySelectorAll('[data-wizard-dot]'));
  var currentStep = 0;
  var isTransitioning = false;

  var cloudinaryConfig = window.TailorTail && window.TailorTail.cloudinary || {};

  function uploadPhotoForCart(file, callback) {
    if (cloudinaryConfig.cloudName && cloudinaryConfig.uploadPreset) {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', cloudinaryConfig.uploadPreset);
      formData.append('folder', 'tailortail-pets');

      var url = 'https://api.cloudinary.com/v1_1/' + cloudinaryConfig.cloudName + '/image/upload';
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          var response = JSON.parse(xhr.responseText);
          callback(response.secure_url);
        } else {
          resizeForCartFallback(file, callback);
        }
      };
      xhr.onerror = function() {
        resizeForCartFallback(file, callback);
      };
      xhr.send(formData);
    } else {
      resizeForCartFallback(file, callback);
    }
  }

  function resizeForCartFallback(file, callback) {
    var img = new Image();
    img.onload = function() {
      var maxDim = 100;
      var w = img.width;
      var h = img.height;
      if (w > maxDim || h > maxDim) {
        if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
        else { w = Math.round(w * maxDim / h); h = maxDim; }
      }
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      callback(canvas.toDataURL('image/jpeg', 0.5));
    };
    img.src = URL.createObjectURL(file);
  }

  // ─── Step Navigation ───
  function goToStep(index, direction) {
    if (isTransitioning || index < 0 || index >= steps.length || index === currentStep) return;
    isTransitioning = true;

    var oldStep = steps[currentStep];
    var newStep = steps[index];
    var isForward = direction === 'forward' || index > currentStep;

    oldStep.classList.add('is-sliding-out');

    setTimeout(function() {
      oldStep.classList.remove('is-active', 'is-sliding-out');
      oldStep.hidden = true;

      newStep.hidden = false;
      newStep.classList.add('is-active');
      if (!isForward) {
        newStep.classList.add('is-sliding-in-reverse');
        setTimeout(function() { newStep.classList.remove('is-sliding-in-reverse'); }, 310);
      }

      updateDots(index);
      currentStep = index;
      isTransitioning = false;

      document.dispatchEvent(new CustomEvent('wizard:step-changed'));
      newStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 210);
  }

  var connectors = Array.from(wizard.querySelectorAll('[data-wizard-connector]'));

  function updateDots(activeIndex) {
    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === activeIndex);
      dot.classList.toggle('is-completed', i < activeIndex);
      if (i === activeIndex) {
        dot.setAttribute('aria-current', 'step');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
    connectors.forEach(function(conn, i) {
      conn.classList.toggle('is-completed', i < activeIndex);
    });
  }

  // ─── Button Navigation ───
  wizard.addEventListener('click', function(e) {
    var nextBtn = e.target.closest('[data-wizard-next]');
    var backBtn = e.target.closest('[data-wizard-back]');
    var submitBtn = e.target.closest('[data-wizard-submit]');

    if (nextBtn) {
      if (validateCurrentStep()) {
        goToStep(currentStep + 1, 'forward');
      }
    } else if (backBtn) {
      goToStep(currentStep - 1, 'back');
    } else if (submitBtn) {
      handleWizardSubmit();
    }
  });

  // Dot clicks (jump to completed steps)
  dots.forEach(function(dot, index) {
    dot.addEventListener('click', function() {
      if (index < currentStep) {
        goToStep(index, 'back');
      }
    });
  });

  // ─── Swipe Detection ───
  var touchStartX = 0;
  var touchStartY = 0;
  var isSwiping = false;

  wizard.addEventListener('touchstart', function(e) {
    if (isInputElement(e.target)) return;
    if (e.target.closest('[data-wizard-carousel]')) return;
    touchStartX = e.touches[0].screenX;
    touchStartY = e.touches[0].screenY;
    isSwiping = true;
  }, { passive: true });

  wizard.addEventListener('touchend', function(e) {
    if (!isSwiping) return;
    isSwiping = false;

    var touchEndX = e.changedTouches[0].screenX;
    var touchEndY = e.changedTouches[0].screenY;
    var diffX = touchStartX - touchEndX;
    var diffY = Math.abs(touchStartY - touchEndY);

    if (Math.abs(diffX) < 50 || diffY > Math.abs(diffX)) return;

    if (diffX > 0) {
      if (validateCurrentStep()) goToStep(currentStep + 1, 'forward');
    } else {
      goToStep(currentStep - 1, 'back');
    }
  }, { passive: true });

  function isInputElement(el) {
    var tag = el.tagName.toLowerCase();
    return tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable;
  }

  // ─── Step Validation ───
  function validateCurrentStep() {
    var step = steps[currentStep];
    var stepType = step.getAttribute('data-step-type');
    var isRequired = step.getAttribute('data-step-required') === 'true';

    if (!isRequired) return true;

    switch (stepType) {
      case 'gallery':
        var countrySelector = step.querySelector('[data-country-selector]');
        if (countrySelector) {
          var valueInput = countrySelector.querySelector('[data-country-value-input]');
          if (!valueInput || !valueInput.value) {
            var countryError = countrySelector.querySelector('[data-country-error]');
            if (countryError) countryError.hidden = false;
            shakeElement(countrySelector.querySelector('.country-selector__grid'));
            return false;
          }
          var customWrapper = countrySelector.querySelector('[data-country-custom-wrapper]');
          if (customWrapper && !customWrapper.hidden) {
            var customInput = countrySelector.querySelector('[data-country-custom-input]');
            if (!customInput.value.trim()) {
              customInput.focus();
              customInput.classList.add('form-input--error');
              var customError = countrySelector.querySelector('[data-country-custom-error]');
              if (customError) customError.hidden = false;
              return false;
            }
          }
        }
        return true;

      case 'upload':
        if (!isRequired) return true;
        var firstSlot = step.querySelector('[data-wizard-upload-slot="1"]');
        var uploadSuccess = firstSlot
          ? firstSlot.querySelector('[data-wizard-upload-success]')
          : step.querySelector('[data-wizard-upload-success]');
        if (uploadSuccess && uploadSuccess.hidden) {
          var zoneToShake = firstSlot
            ? firstSlot.querySelector('[data-wizard-upload-zone]')
            : step.querySelector('[data-wizard-upload-zone]');
          shakeElement(zoneToShake);
          return false;
        }
        var uploadPetName = step.querySelector('[data-wizard-pet-name]');
        if (uploadPetName && uploadPetName.hasAttribute('required') && !uploadPetName.value.trim()) {
          uploadPetName.focus();
          uploadPetName.classList.add('form-input--error');
          var uploadPetNameError = step.querySelector('#WizardPetName-error');
          if (uploadPetNameError) uploadPetNameError.hidden = false;
          return false;
        }
        return true;

      case 'country':
        var countrySelect = step.querySelector('[data-wizard-country]');
        if (countrySelect && !countrySelect.value) {
          countrySelect.focus();
          var error = step.querySelector('.form-error');
          if (error) error.hidden = false;
          return false;
        }
        return true;

      case 'style':
        var styleSelect = step.querySelector('[data-wizard-art-style]');
        if (styleSelect && !styleSelect.value) {
          var styleError = step.querySelector('[data-wizard-style-error]');
          if (styleError) styleError.hidden = false;
          shakeElement(step.querySelector('[data-wizard-style-grid]'));
          return false;
        }
        return true;

      case 'options':
        var sizeButtons = step.querySelectorAll('.product-wizard__size-btn, .size-card');
        if (sizeButtons.length > 0) {
          var hasSize = Array.from(sizeButtons).some(function(b) { return b.classList.contains('is-active'); });
          if (!hasSize) {
            shakeElement(step.querySelector('.product-wizard__size-selector, .size-cards'));
            return false;
          }
        }
        var petNameInput = step.querySelector('[data-wizard-pet-name]');
        if (petNameInput && petNameInput.hasAttribute('required') && !petNameInput.value.trim()) {
          petNameInput.focus();
          petNameInput.classList.add('form-input--error');
          var petNameError = step.querySelector('#WizardPetName-error');
          if (petNameError) petNameError.hidden = false;
          return false;
        }
        return true;

      default:
        return true;
    }
  }

  function shakeElement(el) {
    if (!el) return;
    el.style.animation = 'none';
    el.offsetHeight;
    el.style.animation = 'wizardShake 400ms ease';
    setTimeout(function() { el.style.animation = ''; }, 410);
  }

  // ─── Pet Name Validation Clear ───
  var petNameField = wizard.querySelector('[data-wizard-pet-name]');
  if (petNameField) {
    petNameField.addEventListener('input', function() {
      if (this.value.trim()) {
        this.classList.remove('form-input--error');
        var err = wizard.querySelector('#WizardPetName-error');
        if (err) err.hidden = true;
      }
    });
  }

  // ─── Country Radio Selector (Wizard) ───
  initCountrySelector(wizard);

  // When country changes in wizard, filter images immediately and update variant
  var wizardCountrySelect = wizard.querySelector('[data-country-variant-select]');
  if (wizardCountrySelect) {
    wizardCountrySelect.addEventListener('change', function() {
      filterWizardSlidesByOption(this.value);
      updateWizardVariant();
    });
  }

  // Fallback: listen directly to radio buttons when hidden select doesn't exist
  if (!wizardCountrySelect) {
    var countryRadios = wizard.querySelectorAll('[data-country-radio]');
    countryRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        var val = this.value;
        filterWizardSlidesByOption(val);
        updateWizardVariant();
      });
    });
    var customCountryInput = wizard.querySelector('[data-country-custom-input]');
    if (customCountryInput) {
      customCountryInput.addEventListener('input', function() {
        if (this.value.trim()) {
          updateWizardVariant();
        }
      });
    }
  }

  // ─── Art Style Selection (Wizard) ───
  var styleGrid = wizard.querySelector('[data-wizard-style-grid]');
  var styleHidden = wizard.querySelector('[data-wizard-art-style]');

  if (styleGrid && styleHidden) {
    styleGrid.addEventListener('click', function(e) {
      var card = e.target.closest('[data-style-value]');
      if (!card) return;

      styleGrid.querySelectorAll('[data-style-value]').forEach(function(c) {
        c.setAttribute('aria-pressed', 'false');
      });
      card.setAttribute('aria-pressed', 'true');
      styleHidden.value = card.getAttribute('data-style-value');

      var styleError = wizard.querySelector('[data-wizard-style-error]');
      if (styleError) styleError.hidden = true;

      // Filter carousel slides by art style name in alt text
      var selectedStyle = card.getAttribute('data-style-value');
      filterWizardSlidesByOption(selectedStyle);

      // If variant-backed (has data-option-value), update variant selection
      if (card.hasAttribute('data-option-value')) {
        updateWizardVariant();
      }
    });
  }

  // ─── Size & Option Buttons (Wizard) ───
  wizard.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('.product-wizard__size-btn');
    if (sizeBtn) {
      var group = sizeBtn.closest('.product-wizard__size-selector');
      group.querySelectorAll('.product-wizard__size-btn').forEach(function(b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      sizeBtn.classList.add('is-active');
      sizeBtn.setAttribute('aria-pressed', 'true');
      updateWizardVariant();
    }

    var sizeCard = e.target.closest('.size-card');
    if (sizeCard) {
      var cardGroup = sizeCard.closest('.size-cards');
      cardGroup.querySelectorAll('.size-card').forEach(function(c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
      });
      sizeCard.classList.add('is-active');
      sizeCard.setAttribute('aria-pressed', 'true');
      updateWizardVariant();
    }

    var colorSwatch = e.target.closest('.product-wizard__color-swatch');
    if (colorSwatch) {
      var swatchGroup = colorSwatch.closest('.product-wizard__color-swatches');
      swatchGroup.querySelectorAll('.product-wizard__color-swatch').forEach(function(s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      colorSwatch.classList.add('is-active');
      colorSwatch.setAttribute('aria-pressed', 'true');

      var colorLabel = colorSwatch.closest('.product-wizard__field').querySelector('[data-wizard-selected-color]');
      if (colorLabel) colorLabel.textContent = colorSwatch.getAttribute('aria-label');
      updateWizardVariant();
    }

    // Pet Count Cards (Wizard)
    var petCard = e.target.closest('.pet-count-card');
    if (petCard) {
      var petCardsContainer = petCard.closest('[data-pet-count-cards]');
      if (petCardsContainer) {
        petCardsContainer.querySelectorAll('.pet-count-card').forEach(function(c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        petCard.classList.add('is-active');
        petCard.setAttribute('aria-pressed', 'true');

        var wizPetCountSelect = wizard.querySelector('[data-pet-count-select]');
        if (wizPetCountSelect) {
          wizPetCountSelect.value = petCard.getAttribute('data-pet-count-value');
        }
        updateWizardVariant();

        var petCount = parseInt(petCard.getAttribute('data-pet-count') || '1', 10);
        updateWizardUploadSlots(petCount);
      }
    }
  });

  function updateWizardUploadSlots(count) {
    var slots = wizard.querySelectorAll('[data-wizard-upload-slot]');
    slots.forEach(function(slot) {
      var slotNum = parseInt(slot.getAttribute('data-wizard-upload-slot'), 10);
      slot.hidden = slotNum > count;
    });

    var multiHelper = wizard.querySelector('[data-wizard-multi-upload-helper]');
    if (multiHelper) {
      multiHelper.hidden = count <= 1;
    }
  }

  function updateWizardVariant() {
    if (!product) return;

    var selectedOptions = [];
    var variantSelects = Array.from(wizard.querySelectorAll('[data-variant-select]'));
    product.options.forEach(function(optionName, i) {
      var optHandle = optionName.toLowerCase().replace(/\s+/g, '-');
      if (optHandle === 'size') {
        var activeSize = wizard.querySelector('.product-wizard__size-btn.is-active') || wizard.querySelector('.size-card.is-active');
        selectedOptions.push(activeSize ? activeSize.getAttribute('data-option-value') : '');
      } else if (optHandle === 'color' || optHandle === 'colour') {
        var activeColor = wizard.querySelector('.product-wizard__color-swatch.is-active');
        selectedOptions.push(activeColor ? activeColor.getAttribute('data-option-value') : '');
      } else if (optHandle === 'country') {
        var countrySelect = wizard.querySelector('[data-country-variant-select]');
        var countryValueInput = wizard.querySelector('[data-country-value-input]');
        var countryChecked = wizard.querySelector('[data-country-radio]:checked');
        var countryVal = (countrySelect && countrySelect.value) || (countryValueInput && countryValueInput.value) || (countryChecked && countryChecked.value) || '';
        selectedOptions.push(countryVal);
      } else if (optHandle === 'art-style') {
        var artStyleSelect = wizard.querySelector('[data-wizard-art-style]');
        selectedOptions.push(artStyleSelect ? artStyleSelect.value : '');
      } else {
        var select = variantSelects[i] || wizard.querySelector('[data-variant-select]');
        selectedOptions.push(select ? select.value : '');
      }
    });

    var variant = product.variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return opt === selectedOptions[i];
      });
    });

    if (variant) {
      if (variantIdInput) variantIdInput.value = variant.id;

      var priceEls = wizard.querySelectorAll('[data-wizard-price], [data-wizard-atc-price], [data-wizard-summary-price]');
      priceEls.forEach(function(el) { el.textContent = formatMoney(variant.price); });

      var submitBtn = wizard.querySelector('[data-wizard-submit]');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
      }

      // Switch main carousel to variant featured image
      if (variant.featured_image) {
        var targetSrc = variant.featured_image.src.replace(/https?:/, '');
        var wizardSlidesList = Array.from(wizard.querySelectorAll('[data-slide-index]'));
        var matchedSlide = null;
        wizardSlidesList.forEach(function(slide) {
          var img = slide.querySelector('img');
          if (img) {
            var slideSrc = (img.getAttribute('src') || '').replace(/https?:/, '').replace(/\?v=\d+/, '').replace(/&width=\d+/, '');
            var varSrc = targetSrc.replace(/\?v=\d+/, '').replace(/&width=\d+/, '');
            if (slideSrc.split('?')[0] === varSrc.split('?')[0]) {
              matchedSlide = slide;
            }
          }
        });
        if (matchedSlide) {
          var matchedIdx = wizardSlidesList.indexOf(matchedSlide);
          if (matchedIdx >= 0 && matchedIdx !== currentSlide) {
            showSlide(matchedIdx);
          }
        }
      }

      // Filter carousel slides by variant alt text (country first, then generic fallback)
      var wizardFilterValue = null;
      var countryOptIdx = product.options.findIndex(function(o) {
        return o.toLowerCase().replace(/\s+/g, '-') === 'country';
      });
      if (countryOptIdx >= 0) {
        wizardFilterValue = variant.options[countryOptIdx];
      }

      if (!wizardFilterValue) {
        var wizardSlidesList2 = Array.from(wizard.querySelectorAll('[data-slide-index]'));
        for (var wi = 0; wi < product.options.length; wi++) {
          if (wi === countryOptIdx) continue;
          var wOptVal = variant.options[wi];
          if (!wOptVal || wOptVal.length <= 2) continue;
          var wHasMatch = wizardSlidesList2.some(function(slide) {
            var img = slide.querySelector('img');
            var alt = img ? img.getAttribute('alt') || '' : '';
            var altLower = alt.toLowerCase();
            return !altLower.includes('always') && !altLower.includes('variant-only') && altLower.includes(wOptVal.toLowerCase());
          });
          if (wHasMatch) { wizardFilterValue = wOptVal; break; }
        }
      }

      filterWizardSlidesByOption(wizardFilterValue);
    }
  }

  function filterWizardSlidesByOption(filterValue) {
    var wizardSlides = Array.from(wizard.querySelectorAll('[data-slide-index]'));
    var wizardDots = Array.from(wizard.querySelectorAll('[data-slide-dot]'));
    if (!wizardSlides.length) return;

    if (filterValue) {
      var hasMatches = false;
      wizardSlides.forEach(function(slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        var alt = img.getAttribute('alt') || '';
        var altLower = alt.toLowerCase();
        if (!altLower.includes('always') && altLower.includes(filterValue.toLowerCase())) hasMatches = true;
      });

      wizardSlides.forEach(function(slide) {
        var img = slide.querySelector('img');
        if (!img) { slide.style.display = ''; slide.classList.remove('is-active'); return; }
        var alt = img.getAttribute('alt') || '';
        var altLower = alt.toLowerCase();
        var isAlways = altLower.includes('always');
        var isVariantOnly = altLower.includes('variant-only');
        var matchesFilter = altLower.includes(filterValue.toLowerCase());

        if (isAlways) {
          slide.style.display = '';
        } else if (hasMatches) {
          slide.style.display = matchesFilter ? '' : 'none';
        } else {
          slide.style.display = isVariantOnly ? 'none' : '';
        }
        slide.classList.remove('is-active');
      });

      wizardDots.forEach(function(dot) { dot.style.display = 'none'; dot.classList.remove('is-active'); });
      var visibleSlides = wizardSlides.filter(function(s) { return s.style.display !== 'none'; });
      if (visibleSlides.length > 0) {
        visibleSlides[0].classList.add('is-active');
        currentSlide = wizardSlides.indexOf(visibleSlides[0]);
        visibleSlides.forEach(function(s, i) {
          if (wizardDots[i]) { wizardDots[i].style.display = ''; }
        });
        if (wizardDots[0]) wizardDots[0].classList.add('is-active');
      }
    } else {
      wizardSlides.forEach(function(slide) {
        var img = slide.querySelector('img');
        if (!img) { slide.style.display = ''; return; }
        var alt = img.getAttribute('alt') || '';
        var isVariantOnly = alt.toLowerCase().includes('variant-only');
        slide.style.display = isVariantOnly ? 'none' : '';
      });
      wizardDots.forEach(function(dot) { dot.style.display = ''; });
    }
  }

  // ─── Image Carousel (Gallery Step) ───
  var slides = Array.from(wizard.querySelectorAll('[data-slide-index]'));
  var slideDots = Array.from(wizard.querySelectorAll('[data-slide-dot]'));
  var currentSlide = 0;

  // Hide variant-only slides on initial load
  slides.forEach(function(slide) {
    var img = slide.querySelector('img');
    var alt = img ? img.getAttribute('alt') || '' : '';
    if (alt.toLowerCase().includes('variant-only')) {
      slide.style.display = 'none';
    }
  });

  // Initialize wizard state from URL variant parameter
  if (variantIdInput && variantIdInput.value && product) {
    updateWizardVariant();
  }

  function getVisibleSlides() {
    return slides.filter(function(s) { return s.style.display !== 'none'; });
  }

  var carouselEl = wizard.querySelector('[data-wizard-carousel]');
  if (carouselEl && slides.length > 1) {
    var carouselStartX = 0;

    carouselEl.addEventListener('touchstart', function(e) {
      carouselStartX = e.touches[0].screenX;
    }, { passive: true });

    carouselEl.addEventListener('touchend', function(e) {
      var diff = carouselStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) < 50) return;

      var visible = getVisibleSlides();
      var visibleIdx = visible.indexOf(slides[currentSlide]);
      if (visibleIdx === -1) visibleIdx = 0;

      if (diff > 0 && visibleIdx < visible.length - 1) {
        showSlide(slides.indexOf(visible[visibleIdx + 1]));
      } else if (diff < 0 && visibleIdx > 0) {
        showSlide(slides.indexOf(visible[visibleIdx - 1]));
      }
    }, { passive: true });
  }

  function showSlide(index) {
    slides.forEach(function(s) {
      s.classList.remove('is-active');
      var vid = s.querySelector('video');
      if (vid) vid.pause();
    });
    slideDots.forEach(function(d) { d.classList.remove('is-active'); });

    if (slides[index]) slides[index].classList.add('is-active');
    currentSlide = index;

    var visible = getVisibleSlides();
    var visibleIdx = visible.indexOf(slides[index]);
    if (visibleIdx >= 0 && slideDots[visibleIdx]) slideDots[visibleIdx].classList.add('is-active');
  }

  // ─── Carousel Arrow Navigation (Mobile) ───
  var slidePrev = wizard.querySelector('[data-slide-prev]');
  var slideNext = wizard.querySelector('[data-slide-next]');

  if (slidePrev && slideNext && slides.length > 1) {
    slidePrev.addEventListener('click', function(e) {
      e.stopPropagation();
      var visible = getVisibleSlides();
      var visibleIdx = visible.indexOf(slides[currentSlide]);
      if (visibleIdx === -1) visibleIdx = 0;
      var nextVisibleIdx = visibleIdx > 0 ? visibleIdx - 1 : visible.length - 1;
      showSlide(slides.indexOf(visible[nextVisibleIdx]));
    });

    slideNext.addEventListener('click', function(e) {
      e.stopPropagation();
      var visible = getVisibleSlides();
      var visibleIdx = visible.indexOf(slides[currentSlide]);
      if (visibleIdx === -1) visibleIdx = 0;
      var nextVisibleIdx = visibleIdx < visible.length - 1 ? visibleIdx + 1 : 0;
      showSlide(slides.indexOf(visible[nextVisibleIdx]));
    });
  }

  // ─── Photo Upload (Wizard) — supports multiple slots ───
  var uploadSlots = wizard.querySelectorAll('[data-wizard-upload-slot]');
  if (uploadSlots.length === 0) {
    // Fallback: treat the whole upload step as a single slot
    var singleZone = wizard.querySelector('[data-wizard-upload-zone]');
    if (singleZone) uploadSlots = [singleZone.parentElement];
  }

  uploadSlots.forEach(function(slot) {
    var zone = slot.querySelector('[data-wizard-upload-zone]');
    var input = slot.querySelector('[data-wizard-upload-input]');
    var idle = slot.querySelector('[data-wizard-upload-idle]');
    var success = slot.querySelector('[data-wizard-upload-success]');
    var previewImg = slot.querySelector('[data-wizard-upload-preview-img]');
    var changeBtn = slot.querySelector('[data-wizard-upload-change]');

    if (!zone || !input) return;

    zone.addEventListener('click', function(e) {
      if (e.target.closest('[data-wizard-upload-change]')) return;
      if (!success || success.hidden) {
        input.click();
      }
    });

    input.addEventListener('change', function() {
      var file = this.files[0];
      if (!file) return;

      var validTypes = ['image/jpeg', 'image/png', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a JPG, PNG, or WebP image.');
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        alert('File must be under 20MB.');
        return;
      }

      var reader = new FileReader();
      reader.onload = function(e) {
        if (previewImg) previewImg.src = e.target.result;
        if (idle) idle.hidden = true;
        if (success) success.hidden = false;
        zone.style.borderStyle = 'solid';
        zone.style.borderColor = 'var(--color-secondary)';
      };
      reader.readAsDataURL(file);

      var hiddenUrl = slot.querySelector('[data-wizard-photo-url]');
      if (hiddenUrl) {
        uploadPhotoForCart(file, function(urlOrData) {
          hiddenUrl.value = urlOrData;
        });
      }
    });

    if (changeBtn) {
      changeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (idle) idle.hidden = false;
        if (success) success.hidden = true;
        zone.style.borderStyle = '';
        zone.style.borderColor = '';
        input.value = '';
        var hiddenUrl = slot.querySelector('[data-wizard-photo-url]');
        if (hiddenUrl) hiddenUrl.value = '';
      });
    }

    // Drag and drop
    zone.addEventListener('dragover', function(e) {
      e.preventDefault();
      zone.classList.add('is-dragover');
    });
    zone.addEventListener('dragleave', function() {
      zone.classList.remove('is-dragover');
    });
    zone.addEventListener('drop', function(e) {
      e.preventDefault();
      zone.classList.remove('is-dragover');
      var file = e.dataTransfer.files[0];
      if (file) {
        var dt = new DataTransfer();
        dt.items.add(file);
        input.files = dt.files;
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  // ─── Review Step Summary ───
  function updateSummary() {
    var summaryOptions = wizard.querySelector('[data-wizard-summary-options]');
    if (!summaryOptions) return;

    var lines = [];

    var styleVal = styleHidden ? styleHidden.value : '';
    if (styleVal) lines.push('Style: ' + styleVal);

    var petName = wizard.querySelector('[data-wizard-pet-name]');
    if (petName && petName.value) lines.push('Pet: ' + petName.value);

    var countrySummary = wizard.querySelector('[data-wizard-country]');
    var countryValueSummary = wizard.querySelector('[data-country-value-input]');
    var countryCheckedSummary = wizard.querySelector('[data-country-radio]:checked');
    var countrySummaryVal = (countrySummary && countrySummary.value) || (countryValueSummary && countryValueSummary.value) || (countryCheckedSummary && countryCheckedSummary.value) || '';
    if (countrySummaryVal) lines.push('Country: ' + countrySummaryVal);

    var activePetCount = wizard.querySelector('.pet-count-card.is-active');
    if (activePetCount) lines.push('Pets: ' + activePetCount.getAttribute('data-pet-count-value'));

    var activeSize = wizard.querySelector('.product-wizard__size-btn.is-active') || wizard.querySelector('.size-card.is-active');
    if (activeSize) lines.push('Size: ' + activeSize.getAttribute('data-option-value'));

    var activeColor = wizard.querySelector('.product-wizard__color-swatch.is-active');
    if (activeColor) lines.push('Color: ' + activeColor.getAttribute('aria-label'));

    var notes = wizard.querySelector('[data-wizard-notes]');
    if (notes && notes.value) lines.push('Notes: ' + notes.value.substring(0, 40) + (notes.value.length > 40 ? '...' : ''));

    summaryOptions.innerHTML = lines.join('<br>');

    // Update summary thumbnail to selected variant image
    var summaryImg = wizard.querySelector('[data-wizard-summary-img]');
    if (summaryImg && product && variantIdInput) {
      var selectedVariant = product.variants.find(function(v) {
        return v.id === parseInt(variantIdInput.value, 10);
      });
      if (selectedVariant && selectedVariant.featured_image) {
        summaryImg.src = selectedVariant.featured_image.src;
      }
    }
  }

  // Update summary when entering review step
  var originalGoToStep = goToStep;
  goToStep = function(index, direction) {
    if (steps[index] && steps[index].getAttribute('data-step-type') === 'review') {
      updateSummary();
    }
    originalGoToStep(index, direction);
  };

  // ─── Form Submission ───
  function handleWizardSubmit() {
    if (!product) return;

    var variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : product.variants[0].id;
    if (!variantId || isNaN(variantId)) {
      variantId = product.variants[0].id;
    }
    var properties = {};

    var styleVal = styleHidden ? styleHidden.value : '';
    if (styleVal) properties['Art Style'] = styleVal;

    var activePetCard = wizard.querySelector('.pet-count-card.is-active');
    if (activePetCard) {
      properties['Number of Pets'] = activePetCard.getAttribute('data-pet-count-value');
    }

    var petName = wizard.querySelector('[data-wizard-pet-name]');
    if (petName && petName.value) properties['Pet Name'] = petName.value;

    var country = wizard.querySelector('[data-wizard-country]');
    var countryValueInput = wizard.querySelector('[data-country-value-input]');
    var countryVal = (country && country.value) || (countryValueInput && countryValueInput.value) || '';
    if (countryVal) properties['Country'] = countryVal;

    var notes = wizard.querySelector('[data-wizard-notes]');
    if (notes && notes.value) properties['Notes'] = notes.value;

    var photoInputs = wizard.querySelectorAll('[data-wizard-photo-url]');
    photoInputs.forEach(function(input) {
      if (input.value) {
        var idx = input.getAttribute('data-wizard-photo-url');
        properties['Pet Photo ' + idx] = input.value;
      }
    });

    var submitBtn = wizard.querySelector('[data-wizard-submit]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding...';
    }

    var data = { id: variantId, quantity: 1, properties: properties };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err) { throw new Error(err.description || err.message || 'Failed to add to cart'); });
      return res.json();
    })
    .then(function() {
      if (submitBtn) {
        submitBtn.innerHTML = '&#10003; Added to Cart!';
        submitBtn.style.background = 'var(--color-secondary)';
      }

      return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      if (window.TailorTail && window.TailorTail.updateCartCount) {
        window.TailorTail.updateCartCount(cart.item_count);
      }
      if (window.TailorTail && window.TailorTail.openCartDrawer) {
        window.TailorTail.openCartDrawer();
      }
      setTimeout(function() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart &mdash; <span data-wizard-atc-price>' + formatMoney(parseInt(variantIdInput.value ? findVariantPrice(variantIdInput.value) : product.variants[0].price)) + '</span>';
          submitBtn.style.background = '';
        }
      }, 2500);
    })
    .catch(function(err) {
      console.error('Wizard add to cart error:', err, 'Variant ID:', variantId);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = err.message || 'Try Again';
        submitBtn.style.background = '';
        setTimeout(function() {
          submitBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Try Again';
        }, 3000);
      }
    });
  }

  function findVariantPrice(variantId) {
    var v = product.variants.find(function(variant) { return variant.id === parseInt(variantId); });
    return v ? v.price : product.variants[0].price;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Star Rating Link (Smooth Scroll) ───
  var reviewLink = wizard.querySelector('[data-wizard-reviews-link]');
  if (reviewLink) {
    reviewLink.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.querySelector('#testimonials') || document.querySelector('#product-reviews');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // ─── Wizard FAQ Accordion ───
  var faqContainer = wizard.querySelector('[data-wizard-faq]');
  if (faqContainer) {
    faqContainer.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-wizard-faq-toggle]');
      if (!toggle) return;

      var item = toggle.closest('[data-wizard-faq-item]');
      var isOpen = item.classList.contains('is-open');

      faqContainer.querySelectorAll('[data-wizard-faq-item]').forEach(function(el) {
        el.classList.remove('is-open');
        el.querySelector('[data-wizard-faq-toggle]').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // ─── Size Chart Panel ───
  var sizeChartPanel = wizard.querySelector('[data-wizard-size-chart-panel]');
  var sizeChartToggle = wizard.querySelector('[data-wizard-size-chart-toggle]');
  var sizeChartClose = wizard.querySelector('[data-wizard-size-chart-close]');

  if (sizeChartPanel && sizeChartToggle) {
    sizeChartToggle.addEventListener('click', function() {
      sizeChartPanel.hidden = false;
    });

    if (sizeChartClose) {
      sizeChartClose.addEventListener('click', function() {
        sizeChartPanel.hidden = true;
      });
    }

    sizeChartPanel.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-wizard-unit-tab]');
      if (!tab) return;

      var unit = tab.getAttribute('data-wizard-unit-tab');
      sizeChartPanel.querySelectorAll('[data-wizard-unit-tab]').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      sizeChartPanel.querySelectorAll('[data-wizard-unit-panel]').forEach(function(p) {
        p.hidden = p.getAttribute('data-wizard-unit-panel') !== unit;
      });
    });
  }

})();

// ─── Size Chart Image Modal (event delegation, runs independently) ───
(function() {
  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-size-chart-modal-open]');
    if (openBtn) {
      e.preventDefault();
      var modal = document.querySelector('[data-size-chart-modal]');
      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    }
    var closeBtn = e.target.closest('[data-size-chart-modal-close]');
    if (closeBtn) {
      var modal = document.querySelector('[data-size-chart-modal]');
      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var modal = document.querySelector('[data-size-chart-modal]');
      if (modal && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    }
  });
})();

// ─── Image Guidelines Modal ───
(function() {
  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-image-guidelines-modal-open]');
    if (openBtn) {
      e.preventDefault();
      var modal = document.querySelector('[data-image-guidelines-modal]');
      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    }
    var closeBtn = e.target.closest('[data-image-guidelines-modal-close]');
    if (closeBtn) {
      var modal = document.querySelector('[data-image-guidelines-modal]');
      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var modal = document.querySelector('[data-image-guidelines-modal]');
      if (modal && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    }
  });
})();
